import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/dispute-resolution-application/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
